import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import Footer from "./components/Footer";
import BgSvg3 from "../../svg/website/BgSvg3";
import Dotdotdot from "../../svg/website/Dotdotdot";
import HomeSvg1 from "../../svg/website/HomeSvg1";
import HomeSvg2 from "../../svg/website/HomeSvg2";
import HomeSvg3 from "../../svg/website/HomeSvg3";
import HomeSvg4 from "../../svg/website/HomeSvg4";
import HomeSvg5 from "../../svg/website/HomeSvg5";
import RightArrow from "../../svg/website/RightArrow";
import BgSvg2 from "../../svg/website/BgSvg2";
import Tag1 from "../../svg/website/Tag1";
import Tag2 from "../../svg/website/Tag2";
import Tag3 from "../../svg/website/Tag3";
import Tag4 from "../../svg/website/Tag4";
//
import Sec1Bg from '../../svg/website/mobile/HomeSec1Line'
import Sec3m from '../../svg/website/mobile/Sec3m'
import Sec4mTitle from '../../svg/website/mobile/Sec4mTitle'
import Sec4mContent from '../../svg/website/mobile/Sec4mContent'
export default function Home() {
    const navigate = useNavigate();
    const location = useLocation();
    const navigateTo=(str)=>()=>{
        navigate(str)
    }
    const [windowSize, setWindowSize] = useState(getWindowSize());
    function getWindowSize() {const {innerWidth, innerHeight} = window;return {innerWidth, innerHeight};}
        useEffect(()=>{
            function handleWindowResize() {setWindowSize(getWindowSize()); }
            window.addEventListener('resize', handleWindowResize);
            return () => {window.removeEventListener('resize', handleWindowResize);};
    },[])


    const contactUsRef=useRef(null)
    const aboutusRef=useRef(null)
    const scrollToTop=()=>{
        if(location.hash==='#contactus'){
            contactUsRef.current.scrollIntoView({ })
            return
        }
        if(location.hash==='#aboutus'){
            aboutusRef.current.scrollIntoView({ })
            return
        }
        document.getElementById('navbar').scrollIntoView({ })
        //topRef.current.scrollIntoView({ })
    }
    useEffect(()=>{
        scrollToTop()
    },[location])


    return(
        <div className="relative w-full flex flex-col items-center justify-start bg-main">
            <div className="w-full flex-col flex items-center">
                <div className="relative flex flex-col w-full">
                    <div className="w-full flex flex-row items-center d-flex-m-hidden">
                        <div className="flex flex-1">
                            <img src='./home/hero1.png' className="w-full"></img>
                        </div>
                        <div className="flex flex-1 items-center justify-center">
                            <img src='./home/hero2.png' className="w-full max-w-[637px]"></img>
                        </div>
                    </div>
                    {/* mobile */}
                    <div className="w-full flex flex-col items-center justify-center d-hidden-m-flex mb-[10%]">
                        <div className="flex w-[80%] max-w-[600px]">
                            <img src='./home/herom1.png' className="w-full"></img>
                        </div>
                        <div className="flex w-full items-center justify-center max-w-[600px]">
                            <img src='./home/hero2.png' className="w-[60%] max-w-[637px]"></img>
                        </div>
                    </div>

                    {/*section 1*/}
                    <div ref={aboutusRef} className="relative w-full relative mt-[-10.5vw] d-flex-m-hidden">
                        <BgSvg3 width="100%"/>
                        <div className="w-full h-full absolute top-0 left-0 flex flex-row items-stretch justify-center p-[64px]">
                            <div className="max-w-[1300px] w-full flex flex-row items-stretch justify-between gap-[32px] z-[3]">
                                <div className="flex flex-[2] flex flex-col items-start justify-center gap-[16px]">
                                    <div className="flex flex-row font-[700] text-[48px] text-[#425596]">
                                        關於我們
                                        <Dotdotdot color="white" style={{ marginTop: 5 }} />
                                    </div>
                                    <div className="aboutus_text mt-[24px]">
                                        香港大學教育學院中文教育研究中心為配合香港中學閱讀教學的發展需要，因應教育局頒布的「中學教育課程指引」和「香港學生資訊素養」學習架構（2024）的要求，啟動「提高學生線上閱讀能力」計劃。透過新進的線上閱讀能力的促進，本計劃希冀提高學生的自主學習能力、高階思維能力、跨學科學習能力以及綜合應用知識的能力等。
                                    </div>
                                    <div className="aboutus_text mt-[24px] text-[#425596] font-[600]">
                                        本團隊研究人員包括：<br/>
                                        首席研究員：鍾竹梅副教授&nbsp;&nbsp;&nbsp;&nbsp;項目經理：梁靜茵女士&nbsp;&nbsp;&nbsp;&nbsp;研究助理：穆潤女士、顧懿寧女士
                                    </div>
                                </div>
                                <div className="d-flex-m-hidden w-[16vw] max-w-[350px] flex-col items-end justify-center">
                                    <HomeSvg1 width="100%"/>
                                </div>
                            </div>
                        </div>
                        <div className="absolute w-[8vw] bottom-[-3vw] left-[10vw] z-[2]">
                            <HomeSvg2 width="100%"/>
                        </div>
                    </div>
                    {/*mobile*/}
                    <div className="relative w-full relative d-hidden-m-flex">
                        <div className="w-full h-full flex flex-col items-stretch justify-center w-full py-[2%] bg-[#c2f3e7]">
                            <Sec1Bg width="100%"/>
                            <div className="max-w-[1300px] w-full flex flex-col items-center px-[24px] justify-between py-[10%]">
                                <div className="flex flex flex-col gap-[16px]">
                                    <div className="flex flex-row font-[700] text-[50px] text-[#425596]">
                                        關於我們
                                        <Dotdotdot color="white" style={{ marginTop: 5 }} />
                                    </div>
                                    <div className="text-[18px] mt-[32px]">
                                        香港大學教育學院中文教育研究中心為配合香港中學閱讀教學的發展需要，因應教育局頒布的「中學教育課程指引」和「香港學生資訊素養」學習架構（2024）的要求，啟動「提高學生線上閱讀能力」計劃。透過新進的線上閱讀能力的促進，本計劃希冀提高學生的自主學習能力、高階思維能力、跨學科學習能力以及綜合應用知識的能力等。
                                    </div>
                                    <div className="text-[18px] mt-[24px] text-[#425596] font-[600]">
                                        本團隊研究人員包括：<br/>
                                        首席研究員：鍾竹梅副教授<br/>
                                        項目經理：梁靜茵女士 <br/>研究助理：穆潤女士、顧懿寧女士
                                    </div>
                                </div>
                                <div className="w-[70%] flex-col items-end justify-center mt-[10%] max-w-[400px]">
                                    <HomeSvg1 width="100%"/>
                                </div>
                            </div>
                            <Sec1Bg width="100%" className='mb-[5%]'/>
                        </div>
                        <div className="absolute w-[16vw] bottom-[-11vw] left-[41.6vw] z-[2]">
                            <HomeSvg2 width="100%"/>
                        </div>
                    </div>



                    {/*section 2*/}

                    <div className="relative w-full flex flex-col items-center justify-center py-[150px] px-[64px] d-flex-m-hidden">
                        <div className="max-w-[1300px] w-full flex flex-col items-stretch justify-start">
                            <div className="flex flex-row font-[700] text-[50px] text-[#425596] mb-[8vw]">
                                參與計劃的好處
                                <Dotdotdot style={{ marginTop: 5 }} />
                            </div>
                            <HomeSvg5 width='100%'/>
                            <div className="w-full flex flex-row gap-[10%] mt-[8vw]">
                                <div onClick={()=>{navigate('/details')}} className="w-[285px] px-[32px] py-[8px] bg-[#425596] text-[white] text-[20px] font-[700] rounded-[99px] flex justify-between items-center cursor-pointer hover:opacity-[.5]">
                                    更多資訊
                                    <RightArrow/>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*mobile*/}
                    <div className="relative w-full flex flex-col items-center justify-center py-[150px] px-[64px] d-hidden-m-flex">
                        <div className="w-full flex flex-col">
                            <div className="flex flex-row font-[700] text-[50px] text-[#425596] mb-[8vw]">
                                參與計劃的好處
                                <Dotdotdot style={{ marginTop: 5 }} />
                            </div>
                            <div className="w-full flex flex-col items-center gap-[10%] mt-[8vw]">
                                <div className="flex-[2] h-full flex flex-col items-center justify-center w-[60%] max-w-[300px]">
                                    <div className="flex flex-col items-start relative">
                                        <Tag1 width='100%'/>
                                        <div className="flex flex-row items-center gap-2 text-[26px] mt-[24px]">
                                            <Dotdotdot color='#FF7458' style={{ marginTop: 10 }} />
                                            培養學生閱讀的高階思維能力
                                        </div>
                                    </div>
                                    <div className="flex flex-col items-end mt-[36px]">
                                        <Tag2 width='100%'/>
                                        <div className="flex flex-row items-center gap-2 text-[26px] mt-[24px]">
                                            為學生自主學習提供資源
                                            <Dotdotdot color='#24EAA8' style={{ marginTop: 10 }} />
                                        </div>
                                    </div>
                                    <div className="flex flex-col items-start mt-[36px] relative">
                                        <Tag3 width='100%'/>
                                        <div className="flex flex-row items-center gap-2 text-[26px] mt-[24px]">
                                            <Dotdotdot color='#24EAA8' style={{ marginTop: 10 }} />
                                            為教師教學與專業發展提供資源
                                        </div>
                                    </div>
                                    <div className="flex flex-col items-end mt-[36px]">
                                        <Tag4 width='100%'/>
                                        <div className="flex flex-row items-center gap-2 text-[26px] mt-[24px]">
                                            即時回饋，進行針對性教學
                                            <Dotdotdot color='#FF7458' style={{ marginTop: 10 }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-full flex flex-row items-center justify-center gap-[10%] mt-[8vw]">
                                <div onClick={()=>{navigate('/details')}} className="w-[285px] px-[32px] py-[8px] bg-[#425596] text-[white] text-[20px] font-[700] rounded-[99px] flex justify-between items-center cursor-pointer hover:opacity-[.5]">
                                    更多資訊
                                    <RightArrow/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/*section 3*/}
                <div ref={contactUsRef}></div>
                <div className="w-full d-flex-m-hidden">
                    <HomeSvg4 navigate={navigateTo} width='100%'/>
                </div>
                {/*mobile*/}
                <div className="w-full d-hidden-m-flex bg-[#FFFFFF66] py-[10%] relative">
                    <div className="absolute w-[100%] top-[-9vw] z-[2] rotate-[180deg] flex flex-row items-center justify-center">
                        <HomeSvg2 width="15%"/>
                    </div>
                    <Sec3m navigate={navigateTo} width='100%'/>
                </div>
                <div className="w-full d-hidden-m-flex bg-[#FFFFFF66] py-[10%] relative flex flex-col items-center justify-center">
                    <div className="absolute w-full h-[60%] top-0 left-0 bg-[#c4f1eb]" style={{zIndex:0}}>

                    </div>
                    <div className="absolute w-full h-[40%] bottom-0 left-0">
                        
                    </div>
                    <Sec4mTitle width="60%" style={{zIndex:1}}/>
                    <Sec4mContent width="60%" className='mt-[5%]' style={{zIndex:1}}/>
                </div>
                {/*footer */}
                <Footer/>
            </div>
         
            
        </div>
    )
}